// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"720":"47573b4e","908":"97823a11"}[chunkId] + ".chunk.js";
};